import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "sonner";
import { ShopProvider } from "@/lib/shop";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { FloatingWhatsApp } from "@/components/FloatingWhatsApp";
import Home from "@/pages/Home";
import Products from "@/pages/Products";
import ProductDetail from "@/pages/ProductDetail";
import Basket from "@/pages/Basket";
import Checkout from "@/pages/Checkout";
import PaymentResult from "@/pages/PaymentResult";
import TrackOrder from "@/pages/TrackOrder";
import Account from "@/pages/Account";
import ResetPassword from "@/pages/ResetPassword";
import VerifyEmail from "@/pages/VerifyEmail";
import Unsubscribed from "@/pages/Unsubscribed";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Legal from "@/pages/Legal";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminPortal from "@/pages/admin/AdminPortal";

const ScrollToTop = () => {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);
    return null;
};

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <ShopProvider>
                    <ScrollToTop />
                    <Toaster position="top-center" richColors />
                    <Header />
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/products" element={<Products />} />
                        <Route path="/products/:id" element={<ProductDetail />} />
                        <Route path="/basket" element={<Basket />} />
                        <Route path="/checkout" element={<Checkout />} />
                        <Route path="/payment/success" element={<PaymentResult outcome="success" />} />
                        <Route path="/payment/cancel" element={<PaymentResult outcome="cancel" />} />
                        <Route path="/track/:orderNumber" element={<TrackOrder />} />
                        <Route path="/account" element={<Account />} />
                        <Route path="/reset-password" element={<ResetPassword />} />
                        <Route path="/verify-email" element={<VerifyEmail />} />
                        <Route path="/unsubscribed" element={<Unsubscribed />} />
                        <Route path="/about" element={<About />} />
                        <Route path="/contact" element={<Contact />} />
                        <Route path="/privacy" element={<Legal page="privacy" />} />
                        <Route path="/terms" element={<Legal page="terms" />} />
                        <Route path="/admin/login" element={<AdminLogin />} />
                        <Route path="/admin/*" element={<AdminPortal />} />
                    </Routes>
                    <Footer />
                    <FloatingWhatsApp />
                </ShopProvider>
            </BrowserRouter>
        </div>
    );
}

export default App;
